// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence, useAnimation } from "framer-motion";
// import { ChevronDown } from "lucide-react";
// import { Link } from "react-router-dom";
// import "./Navbar.css";

// /* ================= SERVICES ================= */
// const servicesMenu = [
//   { label: "Website Development", path: "/services/web" },
//   { label: "Mobile App Development", path: "/services/mobile" },
//   { label: "E-Commerce Development", path: "/services/ecommerce" },
//   { label: "Cloud Solutions", path: "/services/cloud" },
//   { label: "Digital Marketing", path: "/services/digital" },
//   { label: "Transcription & Translation", path: "/services/transcription" },
//   { label: "Audio & Voice Dataset Services", path: "/services/audio-voice" },
//   { label: "NLP & LLM Dataset Services", path: "/services/nlp-llm" },
//   { label: "Image Dataset Services", path: "/services/image-photo" },
//   { label: "Video Dataset Services", path: "/services/video" },
//   { label: "2D & 3D Dataset Services", path: "/services/2d3d" },
//   { label: "AI Training Data Services", path: "/services/ai-training" },
//   { label: "Categorizing & Tagging", path: "/services/categorizing-tagging" },
//   { label: "Phonetic Transcription", path: "/services/phonetic-transcription" },
// ];

// /* ================= PRODUCTS ================= */
// const productsMenu = [
//   { label: "ERP System", path: "/Erp" },
//   { label: "CRM System", path: "/Crm" },
//   { label: "HRM System", path: "/Hrm" },
//   { label: "Billing & Invoicing", path: "/Billing" },

// ];

// /* ================= NAV ITEMS ================= */
// const navItems = [
//   { label: "Home", path: "/" },
//   { label: "About", path: "/about" },
//   { label: "Company", path: "/company" },
//   { label: "Products", dropdown: productsMenu },
//   { label: "Services", dropdown: servicesMenu },
//   { label: "Careers", path: "/careers" },
// ];

// /* ================= HAMBURGER ================= */
// const Hamburger = ({ open, setOpen }) => {
//   const top = useAnimation();
//   const bottom = useAnimation();

//   useEffect(() => {
//     if (open) {
//       top.start({ d: "M3 3L21 21" });
//       bottom.start({ d: "M3 21L21 3" });
//     } else {
//       top.start({ d: "M0 8.5L24 8.5" });
//       bottom.start({ d: "M0 15.5L24 15.5" });
//     }
//   }, [open]);

//   return (
//     <button className="lg:hidden z-50" onClick={() => setOpen(!open)}>
//       <svg width="24" height="24" viewBox="0 0 24 24">
//         <motion.path animate={top} stroke="black" strokeWidth="2" fill="none" />
//         <motion.path
//           animate={bottom}
//           stroke="black"
//           strokeWidth="2"
//           fill="none"
//         />
//       </svg>
//     </button>
//   );
// };

// /* ================= MOBILE MENU ================= */
// const MobileMenu = ({ open, setOpen }) => {
//   const [openDropdown, setOpenDropdown] = useState(null);

//   return (
//     <AnimatePresence>
//       {open && (
//         <motion.div
//           initial={{ x: "100%" }}
//           animate={{ x: 0 }}
//           exit={{ x: "100%" }}
//           transition={{ duration: 0.35 }}
//           className="fixed inset-0 bg-white z-40 flex flex-col"
//         >
//           <div className="flex justify-between px-6 py-4 border-b">
//             <Link to="/" className="navbar-brand brand-motion">
//               INFRONEX
//             </Link>
//           </div>

//           <div className="flex-1 px-6 py-6 space-y-6 overflow-y-auto">
//             {navItems.map((item) => (
//               <div key={item.label}>
//                 {item.dropdown ? (
//                   <>
//                     <button
//                       onClick={() =>
//                         setOpenDropdown(
//                           openDropdown === item.label ? null : item.label
//                         )
//                       }
//                       className="w-full flex justify-between font-semibold"
//                     >
//                       {item.label}
//                       <ChevronDown
//                         className={`w-4 h-4 transition-transform ${
//                           openDropdown === item.label ? "rotate-180" : ""
//                         }`}
//                       />
//                     </button>

//                     <AnimatePresence>
//                       {openDropdown === item.label && (
//                         <motion.div
//                           initial={{ height: 0, opacity: 0 }}
//                           animate={{ height: "auto", opacity: 1 }}
//                           exit={{ height: 0, opacity: 0 }}
//                           className="ml-4 mt-4 space-y-3 max-h-[300px] overflow-y-auto custom-scrollbar"
//                         >
//                           {item.dropdown.map((sub) => (
//                             <Link
//                               key={sub.label}
//                               to={sub.path}
//                               onClick={() => setOpen(false)}
//                               className="block text-sm text-gray-600 hover:text-blue-600"
//                             >
//                               {sub.label}
//                             </Link>
//                           ))}
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </>
//                 ) : (
//                   <Link
//                     to={item.path}
//                     onClick={() => setOpen(false)}
//                     className="block font-semibold"
//                   >
//                     {item.label}
//                   </Link>
//                 )}
//               </div>
//             ))}
//           </div>

//           <div className="px-6 pb-6">
//             <Link
//               to="/contact"
//               onClick={() => setOpen(false)}
//               className="block text-center bg-[#0A0F2C] text-white py-3 rounded-lg font-semibold"
//             >
//               Contact Us
//             </Link>
//           </div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };

// /* ================= DESKTOP DROPDOWN ================= */
// const DesktopDropdown = ({ items, open }) => (
//   <AnimatePresence>
//     {open && (
//       <motion.div
//         initial={{ opacity: 0, y: 10 }}
//         animate={{ opacity: 1, y: 0 }}
//         exit={{ opacity: 0, y: 10 }}
//         className="absolute top-full left-0 mt-3 bg-white shadow-xl rounded-xl py-3
//                    min-w-[260px] max-h-[380px] overflow-y-auto border custom-scrollbar"
//       >
//         {items.map((item) => (
//           <Link
//             key={item.label}
//             to={item.path}
//             className="block px-6 py-2 text-sm font-medium text-gray-700
//                        hover:bg-blue-50 hover:text-blue-600"
//           >
//             {item.label}
//           </Link>
//         ))}
//       </motion.div>
//     )}
//   </AnimatePresence>
// );

// /* ================= NAVBAR ================= */
// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);

//   return (
//     <nav className="bg-white border-b sticky top-0 z-[9999]">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="flex h-16 items-center justify-between">
//           <Link to="/" className="navbar-brand brand-motion">
//             INFRONEX
//           </Link>

//           <ul className="hidden lg:flex gap-10 items-center">
//             {navItems.map((item) => (
//               <li
//                 key={item.label}
//                 className="relative"
//                 onMouseEnter={() =>
//                   item.dropdown && setOpenDropdown(item.label)
//                 }
//                 onMouseLeave={() => setOpenDropdown(null)}
//               >
//                 {item.dropdown ? (
//                   <>
//                     <button className="flex items-center gap-1 font-semibold">
//                       {item.label}
//                       <ChevronDown className="w-4 h-4" />
//                     </button>
//                     <DesktopDropdown
//                       items={item.dropdown}
//                       open={openDropdown === item.label}
//                     />
//                   </>
//                 ) : (
//                   <Link to={item.path} className="font-semibold">
//                     {item.label}
//                   </Link>
//                 )}
//               </li>
//             ))}
//           </ul>

//           <Link
//             to="/contact"
//             className="hidden lg:block bg-[#0A0F2C] text-white px-6 py-2.5 rounded-md font-semibold"
//           >
//             Contact Us
//           </Link>

//           <Hamburger open={menuOpen} setOpen={setMenuOpen} />
//         </div>
//       </div>

//       <MobileMenu open={menuOpen} setOpen={setMenuOpen} />
//     </nav>
//   );
// };

// export default Navbar;

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence, useAnimation } from "framer-motion";
// import { ChevronDown, ArrowRight, X, Menu } from "lucide-react";
// import { Link } from "react-router-dom";
// import "./Navbar.css";

// /* ================= DATA ================= */
// const servicesMenu = [
//   { label: "Website Development", path: "/services/web" },
//   { label: "Mobile App Development", path: "/services/mobile" },
//   { label: "E-Commerce Development", path: "/services/ecommerce" },
//   { label: "Cloud Solutions", path: "/services/cloud" },
//   { label: "Digital Marketing", path: "/services/digital" },
//   { label: "Transcription & Translation", path: "/services/transcription" },
//   { label: "Audio & Voice Datasets", path: "/services/audio-voice" },
//   { label: "NLP & LLM Datasets", path: "/services/nlp-llm" },
//   { label: "Image Dataset Services", path: "/services/image-photo" },
//   { label: "Video Dataset Services", path: "/services/video" },
//   { label: "2D & 3D Dataset Services", path: "/services/2d3d" },
//   { label: "AI Training Data", path: "/services/ai-training" },
//   { label: "Categorizing & Tagging", path: "/services/categorizing-tagging" },
//   { label: "Phonetic Transcription", path: "/services/phonetic-transcription" },
// ];

// const productsMenu = [
//   { label: "ERP System", path: "/Erp" },
//   { label: "CRM System", path: "/Crm" },
//   { label: "HRM System", path: "/Hrm" },
//   { label: "Billing & Invoicing", path: "/Billing" },
// ];

// const navItems = [
//   { label: "Home", path: "/" },
//   { label: "About", path: "/about" },
//   { label: "Company", path: "/company" },
//   { label: "Products", dropdown: productsMenu, type: "single" },
//   { label: "Services", dropdown: servicesMenu, type: "grid" },
//   { label: "Careers", path: "/careers" },
// ];

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [mobileDropdown, setMobileDropdown] = useState(null);

//   return (
//     <nav className="bg-white border-b border-slate-100 sticky top-0 z-[9999] w-full h-20 flex items-center">
//       <div className="max-w-7xl mx-auto px-6 w-full flex justify-between items-center">
//         {/* LOGO */}
//         <Link
//           to="/"
//           className=" font-black tracking-tighter text-slate-900 brand-motion"
//         >
//           INFRONEX<span className="text-indigo-600"></span>
//         </Link>

//         {/* DESKTOP MENU */}
//         <ul className="hidden lg:flex items-center gap-4">
//           {navItems.map((item) => (
//             <li
//               key={item.label}
//               className="relative py-7 px-2"
//               onMouseEnter={() => item.dropdown && setOpenDropdown(item.label)}
//               onMouseLeave={() => setOpenDropdown(null)}
//             >
//               {item.dropdown ? (
//                 <>
//                   <button
//                     className={`flex items-center gap-1.5 text-[15px] font-semibold transition-colors ${openDropdown === item.label ? "text-indigo-600" : "text-slate-700"}`}
//                   >
//                     {item.label}
//                     <ChevronDown
//                       size={14}
//                       className={`transition-transform duration-300 ${openDropdown === item.label ? "rotate-180" : ""}`}
//                     />
//                   </button>

//                   {/* Dropdown Logic */}
//                   <AnimatePresence>
//                     {openDropdown === item.label && (
//                       <motion.div
//                         initial={{ opacity: 0, y: 10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: 10 }}
//                         className={`absolute top-full mt-0 bg-white shadow-2xl rounded-2xl border border-slate-100 p-6 z-[9999] ${
//                           item.type === "grid"
//                             ? "fixed left-1/2 -translate-x-1/2 w-[700px] grid grid-cols-2 gap-x-8"
//                             : "left-0 w-[260px] flex flex-col space-y-1"
//                         }`}
//                       >
//                         {item.dropdown.map((sub) => (
//                           <Link
//                             key={sub.label}
//                             to={sub.path}
//                             className="group flex items-center justify-between py-3 px-4 rounded-xl hover:bg-indigo-50 transition-all"
//                           >
//                             <span className="text-[14px] font-medium text-slate-600 group-hover:text-indigo-600">
//                               {sub.label}
//                             </span>
//                             <ArrowRight
//                               size={14}
//                               className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-indigo-600"
//                             />
//                           </Link>
//                         ))}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </>
//               ) : (
//                 <Link
//                   to={item.path}
//                   className="text-[15px] font-semibold text-slate-700 hover:text-indigo-600 transition-colors"
//                 >
//                   {item.label}
//                 </Link>
//               )}
//             </li>
//           ))}
//         </ul>

//         {/* CTA */}
//         <div className="flex items-center gap-4">
//           <Link
//             to="/contact"
//             className="hidden lg:block bg-slate-900 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-600 transition-all"
//           >
//             Contact Us
//           </Link>

//           {/* MOBILE HAMBURGER (Using your logic) */}
//           <button
//             className="lg:hidden p-2 text-slate-900"
//             onClick={() => setMenuOpen(!menuOpen)}
//           >
//             {menuOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>
//       </div>

//       {/* MOBILE MENU (Your requested old logic) */}
//       <AnimatePresence>
//         {menuOpen && (
//           <motion.div
//             initial={{ x: "100%" }}
//             animate={{ x: 0 }}
//             exit={{ x: "100%" }}
//             transition={{ duration: 0.35 }}
//             className="fixed inset-0 bg-white z-[9999] flex flex-col lg:hidden"
//           >
//             <div className="flex justify-between items-center px-6 h-20 border-b">
//               <span className=" text-slate-900 brand-motion">
//                 INFRONEX
//               </span>
//               <button onClick={() => setMenuOpen(false)}>
//                 <X size={28} />
//               </button>
//             </div>

//             <div className="flex-1 px-6 py-8 space-y-6 overflow-y-auto">
//               {navItems.map((item) => (
//                 <div key={item.label}>
//                   {item.dropdown ? (
//                     <>
//                       <button
//                         onClick={() =>
//                           setMobileDropdown(
//                             mobileDropdown === item.label ? null : item.label,
//                           )
//                         }
//                         className="w-full flex justify-between items-center font-bold text-lg text-slate-800"
//                       >
//                         {item.label}
//                         <ChevronDown
//                           className={`transition-transform ${mobileDropdown === item.label ? "rotate-180" : ""}`}
//                         />
//                       </button>
//                       {mobileDropdown === item.label && (
//                         <div className="ml-4 mt-4 space-y-4 border-l-2 border-indigo-50 pl-4">
//                           {item.dropdown.map((sub) => (
//                             <Link
//                               key={sub.label}
//                               to={sub.path}
//                               onClick={() => setMenuOpen(false)}
//                               className="block text-slate-500 font-medium"
//                             >
//                               {sub.label}
//                             </Link>
//                           ))}
//                         </div>
//                       )}
//                     </>
//                   ) : (
//                     <Link
//                       to={item.path}
//                       onClick={() => setMenuOpen(false)}
//                       className="block font-bold text-lg text-slate-800"
//                     >
//                       {item.label}
//                     </Link>
//                   )}
//                 </div>
//               ))}
//             </div>

//             <div className="p-6">
//               <Link
//                 to="/contact"
//                 onClick={() => setMenuOpen(false)}
//                 className="block w-full text-center bg-slate-900 text-white py-4 rounded-xl font-bold"
//               >
//                 Contact Us
//               </Link>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </nav>
//   );
// };

// export default Navbar;



import React, { useState } from "react";
import { ChevronDown, X, Menu } from "lucide-react";
import { Link } from "react-router-dom";
import "./Navbar.css";

/* ================= DATA ================= */
const servicesMenu = [
  { label: "Website Development", path: "/services/web" },
  { label: "Mobile App Development", path: "/services/mobile" },
  { label: "E-Commerce Development", path: "/services/ecommerce" },
  { label: "Cloud Solutions", path: "/services/cloud" },
  { label: "Transcription & Translation", path: "/services/transcription" },
  { label: "Audio & Voice Datasets", path: "/services/audio-voice" },
  { label: "NLP & LLM Datasets", path: "/services/nlp-llm" },
  { label: "Image Dataset Services", path: "/services/image-photo" },
  { label: "Video Dataset Services", path: "/services/video" },
  { label: "2D & 3D Dataset Services", path: "/services/2d3d" },
  { label: "AI Training Data", path: "/services/ai-training" },
  { label: "Categorizing & Tagging", path: "/services/categorizing-tagging" },
  { label: "Phonetic Transcription", path: "/services/phonetic-transcription" },
];

const productsMenu = [
  { label: "ERP System", path: "/Erp" },
  { label: "CRM System", path: "/Crm" },
  { label: "HRM System", path: "/Hrm" },
  { label: "Billing & Invoicing", path: "/Billing" },
];

const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Company", path: "/company" },
  { label: "Products", dropdown: productsMenu, type: "single" },
  { label: "Services", dropdown: servicesMenu, type: "grid" },
  { label: "Careers", path: "/careers" },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileDropdown, setMobileDropdown] = useState(null);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* LOGO */}
          <div className="flex-shrink-0">
            <Link
              to="/"
              className="text-2xl font-bold text-indigo-600 brand-motion"
            >
              INFRONEX
            </Link>
          </div>

          {/* DESKTOP MENU - Centered */}
          <div className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <div
                key={item.label}
                className="relative"
                onMouseEnter={() =>
                  item.dropdown && setOpenDropdown(item.label)
                }
                onMouseLeave={() => setOpenDropdown(null)}
              >
                {item.dropdown ? (
                  <>
                    <button className="px-4 py-2 text-black hover:text-indigo-600 font-medium flex items-center gap-1 transition-colors">
                      {item.label}
                      <ChevronDown className="w-4 h-4" />
                    </button>

                    {/* Dropdown */}
                    {openDropdown === item.label && (
                      <div
                        className={`absolute top-full left-0 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden ${
                          item.type === "grid"
                            ? "left-1/2 -translate-x-1/2 w-[600px]"
                            : "left-0 w-56"
                        }`}
                      >
                        {item.type === "grid" ? (
                          <div className="grid grid-cols-2 gap-1 p-4">
                            {item.dropdown.map((sub) => (
                              <Link
                                key={sub.label}
                                to={sub.path}
                                className="px-4 py-3 text-black hover:bg-indigo-50 hover:text-indigo-600 rounded-lg transition-colors text-sm font-medium"
                                onClick={() => setOpenDropdown(null)}
                              >
                                {sub.label}
                              </Link>
                            ))}
                          </div>
                        ) : (
                          <div className="py-2">
                            {item.dropdown.map((sub) => (
                              <Link
                                key={sub.label}
                                to={sub.path}
                                className="block px-4 py-2 text-black hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-sm font-medium"
                                onClick={() => setOpenDropdown(null)}
                              >
                                {sub.label}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className="px-4 py-2 text-black hover:text-indigo-600 font-medium transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="bg-slate-900 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-slate-800 transition-colors"
            >
              Contact Us
            </Link>
          </div>

          {/* MOBILE HAMBURGER */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden p-2 text-black hover:text-indigo-600"
          >
            {menuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* MOBILE MENU - Slide from Right */}
      <div
        className={`lg:hidden fixed top-0 right-0 h-full w-full bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Mobile Header */}
          <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
            <Link
              to="/"
              className="text-xl font-bold text-indigo-800 brand-motion"
            >
              INFRONEX
            </Link>
            <button
              onClick={() => setMenuOpen(false)}
              className="p-2 text-black hover:text-indigo-600"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile Menu Items */}
          <div className="flex-1 overflow-y-auto px-4 py-6 space-y-2">
            {navItems.map((item) => (
              <div key={item.label}>
                {item.dropdown ? (
                  <>
                    <button
                      onClick={() =>
                        setMobileDropdown(
                          mobileDropdown === item.label ? null : item.label,
                        )
                      }
                      className="w-full flex justify-between items-center px-4 py-3 text-gray-800 font-semibold hover:bg-gray-50 rounded-lg"
                    >
                      {item.label}
                      <ChevronDown
                        className={`w-5 h-5 transition-transform ${
                          mobileDropdown === item.label ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                    {mobileDropdown === item.label && (
                      <div className="ml-4 mt-2 space-y-1">
                        {item.dropdown.map((sub) => (
                          <Link
                            key={sub.label}
                            to={sub.path}
                            onClick={() => {
                              setMenuOpen(false);
                              setMobileDropdown(null);
                            }}
                            className="block px-4 py-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg font-bold text-sm"
                          >
                            {sub.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => setMenuOpen(false)}
                    className="block px-4 py-3 text-gray-800 font-semibold hover:bg-gray-50 rounded-lg"
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Mobile CTA */}
          <div className="px-4 py-4 border-t border-gray-200">
            <Link
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="block text-center bg-slate-900 text-white py-3 rounded-lg font-semibold hover:bg-slate-800"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </nav>
  );
};

export default Navbar;



